<template>
    <rkm-form ref="RkmForm">
        <rkm-row>
            <rkm-col>
                <span><strong>Profissinal:</strong></span>
                <p>{{ data.form.lotacao.profissional.nome }}</p>
            </rkm-col>

            <rkm-col>
                <span><strong>CBO:</strong></span>
                <p>{{ data.form.lotacao.ocupacao.codigo }} - {{ data.form.lotacao.ocupacao.nome }}</p>
            </rkm-col>

            <rkm-col>
                <span><strong>Paciente:</strong></span>
                <p>{{ data.form.paciente.nome }}</p>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <span><strong>CID10 Principal:</strong> {{ data.model.cid.codigo }} - {{ data.model.cid.nome }}</span>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-area
                    title="Procedimentos Enfermagem"
                    type="section"
                >
                    <rkm-row>
                        <rkm-col>
                            <rkm-table
                                :fields="fields.table"
                                :items="data.form.atendimentoTriagem.procedimentos.concat(
                                    data.form.procedimentos,
                                    data.model.procedimentos
                                )"
                                hide-filters
                                hide-pagination
                                tag="div"
                            >
                                <template v-slot:cell(info)="row">
                                    <div v-if="Number.isInteger(row.item.id)">
                                        <rkm-icon
                                            :id="`pronto-atendimento-procedimento-info-modal-${row.item.id}`"
                                            class="mr-2"
                                            icon="info-circle"
                                        />
                                        <rkm-popover
                                            :target="`pronto-atendimento-procedimento-info-modal-${row.item.id}`"
                                            triggers="hover"
                                        >
                                             <div><strong>Data/Hora:</strong> {{ row.item.dataHora }}</div>
                                             <div><strong>Setor:</strong> {{ row.item.centroCusto.setor.nome }}</div>
                                             <div><strong>Profissional:</strong> {{ row.item.lotacao.profissional.nome }} - {{ row.item.lotacao.ocupacao.nome }}</div>
                                             <div><strong>Class. risco:</strong> {{ row.item.classificacaoRisco.nome }}</div>
                                        </rkm-popover>
                                    </div>
                                </template>
                            </rkm-table>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-area
                    title="Serviços Enfermagem"
                    type="section"
                >
                    <rkm-row>
                        <rkm-col>
                            <rkm-table
                                :fields="fields.enfermagemtable"
                                :items="data.model.servicosEnfermagem"
                                hide-filters
                                hide-pagination
                                tag="div"
                            />
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>


        <rkm-row>
            <rkm-col>
                <rkm-area
                    title="Procedimentos médicos"
                    type="section"
                >
                    <rkm-row>
                        <rkm-col>
                            <rkm-table
                                :fields="fields.table"
                                :items="data.form.atendimentoMedico.procedimentos"
                                hide-filters
                                hide-pagination
                                tag="div"
                            >
                                <template v-slot:cell(info)="row">
                                    <div v-if="Number.isInteger(row.item.id)">
                                        <rkm-icon
                                            :id="`pronto-atendimento-procedimento-info-modal-${row.item.id}`"
                                            class="mr-2"
                                            icon="info-circle"
                                        />
                                        <rkm-popover
                                            :target="`pronto-atendimento-procedimento-info-modal-${row.item.id}`"
                                            triggers="hover"
                                        >
                                             <div><strong>Data/Hora:</strong> {{ row.item.dataHora }}</div>
                                             <div><strong>Setor:</strong> {{ row.item.centroCusto.setor.nome }}</div>
                                             <div><strong>Profissional:</strong> {{ row.item.lotacao.profissional.nome }} - {{ row.item.lotacao.ocupacao.nome }}</div>
                                             <div><strong>Class. risco:</strong> {{ row.item.classificacaoRisco.nome }}</div>
                                        </rkm-popover>
                                    </div>
                                </template>

                                <template v-slot:cell(codigo)="row">
                                    <div v-if="row.item.procedimento.codigo">
                                        {{ row.item.procedimento.codigo | formatProcedimento }}
                                    </div>
                                </template>
                            </rkm-table>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-area
                    title="Procedimentos de exames de imagem"
                    type="section"
                >
                    <rkm-row>
                        <rkm-col>
                            <rkm-table
                                :fields="fields.table"
                                :items="data.form.atendimentoExameImagem.procedimentos"
                                hide-filters
                                hide-pagination
                                tag="div"
                            >
                                <template v-slot:cell(info)="row">
                                    <div v-if="Number.isInteger(row.item.id)">
                                        <rkm-icon
                                            :id="`pronto-atendimento-procedimento-info-modal-${row.item.id}`"
                                            class="mr-2"
                                            icon="info-circle"
                                        />
                                        <rkm-popover
                                            :target="`pronto-atendimento-procedimento-info-modal-${row.item.id}`"
                                            triggers="hover"
                                        >
                                             <div><strong>Data/Hora:</strong> {{ row.item.dataHora }}</div>
                                             <div><strong>Setor:</strong> {{ row.item.centroCusto.setor.nome }}</div>
                                             <div><strong>Profissional:</strong> {{ row.item.lotacao.profissional.nome }} - {{ row.item.lotacao.ocupacao.nome }}</div>
                                             <div><strong>Class. risco:</strong> {{ row.item.classificacaoRisco.nome }}</div>
                                        </rkm-popover>
                                    </div>
                                </template>

                                <template v-slot:cell(codigo)="row">
                                    <div v-if="row.item.procedimento.codigo">
                                        {{ row.item.procedimento.codigo | formatProcedimento }}
                                    </div>
                                </template>
                            </rkm-table>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row>
            <rkm-col>
                <rkm-area
                    title="Desfecho do atendimento"
                    type="section"
                >
                    <rkm-row>
                        <rkm-col>
                            <rkm-form-radio-group
                                @change="handleDesfechoChange"
                                v-model="data.model.finalizacao.desfechoId"
                            >
                                <rkm-form-radio
                                    v-if="this.data.form.atendimentoMedico.solicitouReavaliacao === false"
                                    :value="enums.desfecho.ALTA_MEDICA">
                                        Alta médica
                                    </rkm-form-radio>
                                <rkm-form-radio v-else :value="enums.desfecho.PACIENTE_LIBERADO">Paciente Liberado</rkm-form-radio>
                                <rkm-form-radio :value="enums.desfecho.EVASAO">Evasão</rkm-form-radio>
                            </rkm-form-radio-group>
                        </rkm-col>
                    </rkm-row>
                </rkm-area>
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="data.model.finalizacao.desfechoId == enums.desfecho.ALTA_MEDICA">
            <rkm-col>
                <rkm-form-select
                    :options="data.form.profissionaisAtendimento"
                    :validations="validations.altaMedica.usuarioId"
                    label="Médico"
                    show-default-option
                    text-field="nome"
                    v-model="data.model.finalizacao.altaMedica.lotacaoId"
                    value-field="lotacaoId"
                />
            </rkm-col>
        </rkm-row>

        <rkm-row v-if="data.model.finalizacao.desfechoId == enums.desfecho.EVASAO">
            <rkm-col>
                <rkm-form-textarea
                    :validations="validations.evasao.motivo"
                    label="Motivo da evasão"
                    v-model="data.model.finalizacao.evasao.motivo"
                />
            </rkm-col>
        </rkm-row>

        <modal-impressao ref="ModalImpressao" />

        <ModalAssinaturaEletronica
            :after-sign="afterSign"
            :ref="modalAssinaturaEletronicaRefName"
            @sign="onSign"
            @skip-sign="onSkipSign"
            v-bind="modalAssinaturaEletronicaFaaProps"
        />
    </rkm-form>
</template>

<script>
// Components.
import ModalImpressao from '@/components/pronto-atendimento/impressao/components/impressao/Modal'

// Enums.
import desfecho from '@/enums/pronto-atendimento/desfecho'
import documentoTipo from '@/enums/cadastro/documentoTipo'
import tipoAtendimento from '@/enums/pronto-atendimento/parametrizacao/tipoAtendimento'

// Filters.
import formats from '@/filters/formats'

// Mixins.
import { error, repository, unmask, stringCase, object, prontoAtendimentoAssinaturaEletronica } from '@/mixins'

// Others.
import moment from 'moment'

// Vuex.
import { mapActions } from 'vuex'

export default {
    components: { ModalImpressao },
    computed: {
        validations() {
            return {
                evasao: {
                    motivo: { required: true, min: 1, max: 200 },
                },
                altaMedica: {
                    usuarioId: { required: true }
                }
            }
        },
    },
    created() {
        this.repositories.atendimentoEnfermagem = this.getConectaSusRepository('prontoAtendimento.enfermagem')
        this.repositories.cid = this.getConectaSusRepository('sigtap.cid')
    },
    data: () => ({
        enums: { desfecho, documentoTipo, tipoAtendimento },
        fields: {
            table: [
                { key: 'info', label: '#', class: 'col-min text-nowrap' },
                { key: 'lotacao.ocupacao.codigo', label: 'CBO' },
                { key: 'lotacao.profissional.nome', label: 'Profissional' },
                { key: 'codigo', label: 'Código' },
                { key: 'procedimento.nome', label: 'Procedimento' },
            ],
            enfermagemtable: [
                { key: 'dataHora', label: '#' },
                { key: 'centroCusto.setor.nome', label: 'Setor' },
                { key: 'lotacao.profissional.nome', label: 'Profissional' },
                { key: 'procedimento.codigo', label: 'Código' },
                { key: 'procedimento.nome', label: 'Procedimento' },
            ]
        },
        repositories: {},
    }),
    filters: {
        ...formats,
    },
    methods: {
        ...mapActions(['setLoading', 'unsetLoading']),
        handleDesfechoChange() {
            this.resetDesfecho()
        },
        save() {
            this.$refs.RkmForm.validate().then(response => {
                if (response === true) {
                    if (this.data.model.classificacaoRiscoId === null) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: 'É obrigatório informar a classificação de risco.'
                        })
                    }
                    else if (this.data.model.finalizacao.desfechoId === null) {
                        this.createNotification({
                            type: 'alert',
                            color: 'danger',
                            title: 'Ação não permitida',
                            message: 'Desfecho é obrigatório.'
                        })
                    }
                    else {

                        this.setLoading()

                        let request = {
                            plantaoId: this.plantaoId,
                            atendimentoId: this.data.model.atendimentoId,
                            classificacaoRiscoId: this.data.model.classificacaoRiscoId,
                            alergias: this.data.model.alergias.map(item => {
                                return {
                                    alergiaId: item.alergia.id,
                                    criticidadeId: item.alergia.criticidade.id,
                                    reacoesObservacoes: item.alergia.reacoesObservacoes,
                                }
                            }),
                            medicamentosUso: this.data.model.medicamentosUso,
                            medicamentosUsoContinuo: this.data.model.medicamentosUsoContinuo.map(item => ({
                                medicamentoId: item.medicamento.id
                            })),
                            sinaisVitais: this.data.model.sinaisVitais.map(item => {
                                return {
                                    pa: item.pa || null,
                                    paUnidadeMedidaId: item.pa ? item.paUnidadeMedidaId : null,
                                    glicemia: item.glicemia || null,
                                    temperatura: item.temperatura ? this.unMaskTemperaturaMMDG(item.temperatura) : null,
                                    pulso: item.pulso || null,
                                    respiracao: item.respiracao || null,
                                    saturacao: item.saturacao || null,
                                    intensidadeDor: item.intensidadeDor || null,
                                    cintura: item.cintura || null,
                                }
                            }),
                            gestacao: {
                                gestante: this.data.model.gestacao.gestante,
                                dum: this.data.model.gestacao.dum ? moment(this.data.model.gestacao.dum).format('YYYY-MM-DD') : null,
                            },
                            fatoresRisco: this.data.model.fatoresRisco,
                            fatorRiscoOutro: this.data.model.fatorRiscoOutro,
                            planejamento: this.data.model.planejamento,
                            implementacao: this.data.model.implementacao,
                            avaliacao: this.data.model.avaliacao,
                            historico: this.data.model.historico,
                            exameFisico: this.data.model.exameFisico,
                            diagnostico: this.data.model.diagnostico,
                            observacoes: this.data.model.observacoes,
                            procedimentos: this.data.model.procedimentos.map(item => {
                                return {
                                    procedimentoId: item.procedimento.id,
                                    cidPrincipalId: item.cidPrincipal ? item.cidPrincipal.id : null,
                                    quantidade: item.quantidade,
                                }
                            }),
                            centroCustoIdPara: this.data.model.centroCustoIdPara,
                            servicosEnfermagem: this.data.model.servicosEnfermagem.map(item => {
                                return {
                                    id: isNaN(item.id) ? null : item.id,
                                    statusId: item.status.id,
                                    procedimentoId: item.procedimento.id,
                                    cidId: item.cid ? item.cid.id : null,
                                    horarioRealizacao: item.horarioRealizacao,
                                    observacoes: item.observacoes,
                                }
                            }),
                            anotacoes: this.data.model.anotacoes.map(item => {
                                return {
                                    anotadoEm: moment(item.dataHoraAnotacao, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm'),
                                    descricao: item.anotacao
                                }
                            }),
                        }

                        request.prescricaoInternaAplicacoes = []

                        this.data.model.prescricoesInterna.forEach(prescricao => {

                            prescricao.medicamentos.forEach(medicamento => {

                                medicamento.aplicacoes.filter(a => !a.disabled).forEach(aplicacao => {

                                    request.prescricaoInternaAplicacoes.push({
                                        id: aplicacao.id,
                                        statusId: aplicacao.status.id,
                                        horarioAplicacao: aplicacao.horarioAplicacao,
                                        localAplicacaoId: aplicacao.localAplicacaoId,
                                    })
                                })
                            })
                        })

                        if (this.data.model.avaliacaoAntropometrica.massa || this.data.model.avaliacaoAntropometrica.altura) {
                            request.avaliacaoAntropometrica = {
                                massa: this.data.model.avaliacaoAntropometrica.massa,
                                massaUnidadeMedidaId: this.data.model.avaliacaoAntropometrica.massaUnidadeMedidaId,
                                alturaTipoMedidaId: this.data.model.avaliacaoAntropometrica.alturaTipoMedidaId,
                                altura: this.data.model.avaliacaoAntropometrica.altura,
                                alturaUnidadeMedidaId: this.data.model.avaliacaoAntropometrica.alturaUnidadeMedidaId,
                            }
                        }

                        request.pedidosExames = this.data.model.pedidosExames
                            .map(pedido => {

                                const pedidoData = {
                                    isForm: pedido.isForm,
                                    id: pedido.id,
                                    urgente: pedido.urgente,
                                    justificativa: pedido.justificativa || null,
                                    exames: pedido.exames.map(exame => ({
                                        id: exame.id,
                                        exameId: exame.exame.id,
                                        observacao: exame.observacao || null,
                                        statusId: exame.status.id,
                                        horarioRealizacao: exame.horarioRealizacao,
                                        lotacaoExecutanteId: exame.lotacaoExecutanteId,
                                    })),
                                    files: pedido.files.filter(f => (f instanceof File)),
                                }

                                if (!Number.isInteger(pedido.id)) {

                                    pedidoData.dataSolicitacao = pedido.dataSolicitacao
                                    pedidoData.unidadeExternaEncaminhamentoId = pedido.unidadeExternaEncaminhamentoId
                                    pedidoData.unidadeEncaminhamentoId = pedido.unidadeEncaminhamentoId
                                    pedidoData.medicoSolicitanteEncaminhamento = pedido.medicoSolicitanteEncaminhamento
                                }

                                return pedidoData
                            })

                        if (this.data.model.finalizacao.desfechoId) {
                            request.finalizacao = {
                                desfecho_id: this.data.model.finalizacao.desfechoId,
                            }

                            if (this.data.model.finalizacao.desfechoId === this.enums.desfecho.EVASAO) {
                                request.finalizacao = Object.assign(request.finalizacao , {
                                    evasao: {
                                        motivo: this.data.model.finalizacao.evasao.motivo,
                                    }
                                })

                            } else if (this.data.model.finalizacao.desfechoId === this.enums.desfecho.ALTA_MEDICA) {

                                request.finalizacao = Object.assign(request.finalizacao , {
                                    alta_medica: {
                                        lotacao_id: this.data.model.finalizacao.altaMedica.lotacaoId,
                                    }
                                })
                            }
                        }

                        const formData = this.objectToFormData(this.camelObjectKeysToSnakeRecursive(request))

                        this.repositories.atendimentoEnfermagem.store(formData)
                            .then(({ data }) => {

                                const finish = () => {

                                    this.$refs.ModalImpressao.open(
                                        data.impressoes,
                                        data.atendimentoId,
                                        () => this.$emit('save')
                                    )
                                }

                                if (data.assinar) {

                                    this.afterSign = faaAssinada => {

                                        return this.repositories.atendimentoEnfermagem.storeFaaAssinada(data.id, {
                                            faa_assinada: faaAssinada
                                        })
                                    }

                                    this.onSign = () => finish()
                                    this.onSkipSign = () => finish()

                                    this.askToSignAtendimento(
                                        async () => this.signFaa(
                                            data.atendimentoId,
                                            [{ tipo: 'enfermagem', id: data.id }],
                                            `faa-${data.faaId}-atendimento-enfermagem-${data.id}`
                                        ),
                                        async () => finish()
                                    )
                                }
                                else {

                                    this.showSaveNotification()

                                    finish()
                                }
                            })
                            .catch(this.handleError)
                            .finally(() => this.unsetLoading())
                    }
                }
            })
        },
        resetDesfecho() {
            this.data.model.finalizacao = Object.assign(this.data.model.finalizacao, {
                evasao: {
                    motivo: null,
                }
            })
        },
    },
    mixins: [error, repository, unmask, stringCase, object, prontoAtendimentoAssinaturaEletronica],
    props: {
        data: { type: Object, required: true },
        plantaoId: { type: [String, Number], required: true },
    }
}
</script>